import React from 'react';

/**
 * CreatorInfo Component
 * 
 * Displays creator information in the same format as the legacy HTML site.
 * Can accept a string or an object with href and text properties.
 */
const CreatorInfo = ({ creator }) => {
  if (!creator) return null;

  return (
    <>
      {typeof creator === 'object' && creator.href ? (
        <a 
          href={creator.href} 
          className="link-table"
          target="_blank"
          rel="noopener noreferrer"
        >
          {creator.text}
        </a>
      ) : (
        typeof creator === 'object' ? creator.text : creator
      )}
    </>
  );
};

export default CreatorInfo; 